import React from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';

import ThinkingAnimation from '../../../components/Common/ThinkingAnimation';

interface EditNoteLoadingModalProps {
  open: boolean;
  taskId: string;
  status: string | null;
  ready: boolean;
  error: string | null;
  onClose: () => void;
}

const LOADING_MESSAGES = [
  'Processing your edit request...',
  'Analyzing the note content...',
  'Applying your changes...',
  'Updating sections...',
  'Reviewing modifications...',
];

export const EditNoteLoadingModal: React.FC<EditNoteLoadingModalProps> = ({
  open,
  taskId,
  status,
  ready,
  error,
  onClose,
}) => {
  // Don't allow closing if there's an error
  const handleClose = error ? undefined : onClose;

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          p: 4,
          minWidth: 400,
          maxWidth: 600,
          outline: 'none',
        }}
      >
        {error ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Typography variant="h6" color="error" sx={{ fontWeight: 600 }}>
              Error Processing Edit
            </Typography>
            <Typography sx={{ textAlign: 'center', color: 'text.secondary' }}>{error}</Typography>
            <Button variant="contained" onClick={onClose} sx={{ mt: 2 }}>
              Close
            </Button>
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3,
            }}
          >
            <ThinkingAnimation words={LOADING_MESSAGES} />
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
              Your note is being updated. This may take a moment...
            </Typography>
          </Box>
        )}
      </Box>
    </Modal>
  );
};
